import { CLink, LinkComponentType } from './CLink'
import { DynamicContentType, ImageCardsData } from '@bm-js/atlascloud-shared'
import { useMargin } from '../utils/hooks'
import { CustomerButton } from './CustomerButton'
import { ResponsiveImage } from './ResponsiveImage'

type Props = {
  LinkComponent: LinkComponentType

  content: DynamicContentType<ImageCardsData>
}

export const ImageCards = ({ content, LinkComponent }: Props) => {
  const { cards } = content.data

  const margin = useMargin(content)

  return (
    <div className='@container'>
      <div className={`${margin} grid @2xl:grid-cols-3 gap-14 grid-cols-1`}>
        {cards.map(
          ({ image, header, paragraph, buttonText, buttonLink }, i) => {
            const hasParagraph = !!paragraph?.trim()

            return (
              <div
                key={`imagecard_${content.uuid}_${i}`}
                className='flex flex-col items-start'
              >
                <ResponsiveImage
                  file={image}
                  className='mb-6 w-full rounded-md shadow-md'
                />
                <h2 className='mb-1 text-2xl font-medium text-neutral-800'>
                  {header}
                </h2>
                {hasParagraph && (
                  <p className='flex-grow text-base font-light text-neutral-700'>
                    {paragraph}
                  </p>
                )}
                {!!(buttonLink && buttonText) && (
                  <CLink LinkComponent={LinkComponent} href={buttonLink}>
                    <CustomerButton
                      btnColor='dark'
                      btnType='outline'
                      className={hasParagraph ? 'mt-8' : 'mt-2'}
                    >
                      {buttonText}
                    </CustomerButton>
                  </CLink>
                )}
              </div>
            )
          }
        )}
      </div>
    </div>
  )
}
